import {
  Globe,
  Smartphone,
  Boxes,
  ShoppingCart,
  ShieldCheck,
  Server,
  Database,
  Store,
  PackageSearch,
  Palette,
  Wrench,
  KeyRound,
  Sparkles,
  Rocket,
  GraduationCap,
  Package,
} from "lucide-react";

export const COMPANY = {
  name: "FCY IT CONSULTANCY LTD",
  shortName: "FCY IT",
  companyNumber: "13432441",
  address: "13 Dehar Crescent, London, England, NW9 7BD",
  phone: "07503336761",
  phoneIntl: "+447503336761",
  email: "info@fcyit.com",
  email2: "info@fcyitconsultancy.com",
  domain: "fcyit.com",
  director: "Fuatcan Yetimoglu",
  education: "Bahcesehir University, Istanbul — Computer Instructional & Educational Teaching",
  sicCodes: [
    "47910 — Retail sale via mail order houses or via Internet",
    "62020 — Information technology consultancy activities",
    "62090 — Other information technology service activities",
  ],
};

export const SERVICE_ICONS = {
  "web-development": Globe,
  "mobile-apps": Smartphone,
  "custom-systems": Boxes,
  "amazon-services": Package,
  "cyber-security": ShieldCheck,
  "server-network": Server,
  database: Database,
  shopify: Store,
  "ebay-dropshipping": ShoppingCart,
  "etsy-dropshipping": PackageSearch,
  maintenance: Wrench,
  "microsoft-licenses": KeyRound,
  "adobe-licenses": Palette,
  "ai-solutions": Sparkles,
  "integration-golive": Rocket,
  "it-consultancy": GraduationCap,
};

export const CATEGORIES = ["All", "Build", "Sell", "Secure", "Scale"];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Describe",
    text: "Tell me about your business and what you need — a website, a mobile app, or a complete system. No technical jargon required.",
  },
  {
    step: "02",
    title: "Design",
    text: "I map out the right solution for you — features, technology and timeline, tailored to your goals and budget.",
  },
  {
    step: "03",
    title: "Build",
    text: "Your solution is developed, integrated and thoroughly tested — whether it's a store, an app or a warehouse system.",
  },
  {
    step: "04",
    title: "Launch & Support",
    text: "We go live to the public. I handle deployment, maintenance and security so you can focus on running your business.",
  },
];

export const STATS = [
  { value: 50, suffix: "+", label: "Projects Delivered" },
  { value: 40, suffix: "+", label: "Happy Clients" },
  { value: 16, suffix: "+", label: "Services Offered" },
  { value: 24, suffix: "h", label: "Response Time", prefix: "<" },
];

// Factual client engagements from the owner's invoices, not customer endorsements.
// Add approvedReview: { text, attribution } only after receiving approved wording.
export const TESTIMONIALS = [
  {
    id: "century-holdings",
    name: "CENTURY HOLDINGS & ASSOCIATES (UK) LIMITED",
    category: "E-commerce & mobile apps",
    summary: "E-commerce website development and rebuilding for gitAbi, with mobile shopping and stock-counting app projects.",
    services: ["E-commerce website", "Mobile shopping app", "Stock-counting app"],
    approvedReview: null,
  },
  {
    id: "fcv-academy",
    name: "FCV INTERNATIONAL FOOTBALL ACADEMY LIMITED",
    category: "Android app & web platform",
    summary: "Clock-in and clock-out Android application with an accompanying web panel for employee time tracking.",
    services: ["Android application", "Web panel", "Time tracking"],
    approvedReview: null,
  },
  {
    id: "kbds-builders",
    name: "KBDS BUILDERS LTD",
    category: "Business website",
    summary: "A new business website, including domain and hosting setup, an SSL certificate and a business email address.",
    services: ["Website development", "Domain & hosting", "SSL & business email"],
    approvedReview: null,
  },
  {
    id: "dn-electrics",
    name: "DN ELECTRICS LTD",
    category: "Website design & rebuild",
    summary: "Website rebuilding with navigation, page organisation, photos, descriptions and logo creation.",
    services: ["Website rebuild", "Page & content layout", "Logo creation"],
    approvedReview: null,
  },
];

export const FALLBACK_SERVICES = [
  {
    id: "web-development",
    title: "Website Development",
    category: "Build",
    featured: true,
    description:
      "Any website you can imagine — business sites, personal portfolios, e-commerce stores, even full marketplace platforms.",
    features: ["Business Websites", "Personal Sites", "E-Commerce Stores", "Marketplace Platforms"],
  },
  {
    id: "mobile-apps",
    title: "Mobile App Development",
    category: "Build",
    featured: true,
    description:
      "Native-quality iOS and Android apps built end-to-end — from idea to App Store and Google Play.",
    features: ["iOS Apps", "Android Apps", "App Store Launch", "Feature Integration"],
  },
];
